/* eslint-disable react/prop-types */
import React from 'react';
import { Dropdown } from 'antd';
import { ReactComponent as ThreeDotIcon } from 'assets/icons/New/three-dot-icon.svg';
import cn from 'clsx';
import classes from './ActionDropdown.module.scss';

const ActionDropdown = ({
  items = [],
  placement = 'bottomLeft',
  children,
  className,
  ...other
}) => {
  return (
    <Dropdown
      {...other}
      menu={{ items }}
      placement={placement}
      className={cn(classes.wrapper, className)}>
      {children || (
        <span>
          <ThreeDotIcon />
        </span>
      )}
    </Dropdown>
  );
};

export default ActionDropdown;
